import React from 'react'
import PropTypes from 'prop-types'
import BEMHelper from 'react-bem-helper'

import './index.css'
const classes = new BEMHelper('list')

export default function List ({ children }) {
  return <ul {...classes('')}>{children}</ul>
}

List.propTypes = {
  children: PropTypes.any.isRequired,
}



// WEBPACK FOOTER //
// ./src/components/List/index.js